import Aos from 'aos';
import React, { useEffect } from 'react';
import { FaChevronDown } from 'react-icons/fa';

const formatYear = (year) => {
	return year.split("/").map((part, index) => (
		<span key={index}>
			{index > 0 && <span className='text-neon text-xl font-semibold'> / </span>}
			{part}
		</span>
	));
};

const RespAchievementList = ({ achievement, isOpen, toggleOpen }) => {
	useEffect(() => {
		Aos.init({ duration: 500 });
	}, []);

	return (
		<li data-aos="zoom-in-up" data-aos-offset='50' className="border-b border-gray-600 transition-all duration-500 ease-in-out" >
			{/* Toggle Header */}
			<div
				className="flex items-center justify-between cursor-pointer py-4 transition-all duration-300"
				onClick={toggleOpen}
			>
				<div className="flex items-center gap-4">
					<span className="text-neon font-semibold">{achievement.index}</span>
					<span className="text-sm">{achievement.title}</span>
				</div>
				<FaChevronDown className={`text-neon transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
			</div>

			{/* Smooth Expanding Section */}
			<div
				className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? "max-h-[420px] opacity-100 pb-4" : "max-h-0 opacity-0 pb-0"
					}`}
			>
				<div className="text-gray-300 rounded-md shadow-lg p-4">
					<div className="text-sm mb-2 text-white">{formatYear(achievement.date)}</div>
					<p className="text-sm mb-4 text-gray-400">{achievement.desp}</p>
					<img
						src={achievement.imageUrl}
						alt={`${achievement.title} pic`}
						className="w-full object-cover rounded-lg shadow-md transition-transform duration-500 scale-95 hover:scale-100"
					/>
				</div>
			</div>
		</li>
	);
};

export default RespAchievementList;
